
import CryptoJS from 'crypto-js';
import baseInfo from "./base";

const kay = CryptoJS.enc.Utf8.parse(baseInfo.ku); //十六位十六进制数作为密钥
const iav = CryptoJS.enc.Utf8.parse(baseInfo.iu); //十六位十六进制数作为密钥偏移量
const jK = CryptoJS.enc.Utf8.parse(baseInfo.JIEK);
const ji = CryptoJS.enc.Utf8.parse(baseInfo.JIEi);
//解密方法
export const Decrypt = (word) => {
  let encryptedHexStr = word;
  let decrypt = CryptoJS.AES.decrypt(word, kay, {
    iv: iav,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

//加密方法
export const Encrypt = (word)=> {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, jK, {
    iv: ji,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}





// WEBPACK FOOTER //
// ./src/request/crypt.js